import { TEnumerationType } from "./type";

export type TGameCategoryKey = 'mobile' | 'pc' | 'console' | 'total' | 'totalMarket' | 'mobileGame' | 'pcGame' | 'consoleGame';
export type TGameCategoryValue = 'mobile' | 'pc' | 'console' | 'total';
export type TDataCategoryKey = 'operation' | 'byGames' | 'byCountries' | 'byCompanies' | 'byMainGenre' | 'bySubGenre';
export type TDataCategoryValue = 'operation' | 'games' | 'countries' | 'companies' | 'main_genres' | 'sub_genres';

export interface IGameCategoryProp {
  // 自身的key
  key: TGameCategoryKey | TDataCategoryKey;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: TGameCategoryValue | TDataCategoryValue;
  enumType: TEnumerationType;
};

export type IGameCategory = Record<TGameCategoryKey, IGameCategoryProp>;
export type IDataCategory = Record<TDataCategoryKey, IGameCategoryProp>;

export const GAME_CATEGORY: IGameCategory = {
  mobile: {
    label: 'Mobile',
    labelKey: 'dbi_mobile',
    value: 'mobile',
    key: 'mobile',
    enumType: 'gameCategory',
  },
  pc: {
    label: 'PC',
    labelKey: 'dbi_pc',
    value: 'pc',
    key: 'pc',
    enumType: 'gameCategory',
  },
  console: {
    label: 'Console',
    labelKey: 'dbi_console',
    value: 'console',
    key: 'console',
    enumType: 'gameCategory',
  },
  total: {
    label: 'Total',
    labelKey: 'dbi_total',
    value: 'total',
    key: 'total',
    enumType: 'gameCategory',
  },
  totalMarket: {
    label: 'Total Market',
    labelKey: 'dbi_global_view_total_market',
    value: 'total',
    key: 'totalMarket',
    enumType: 'gameCategory',
  },
  mobileGame: {
    label: 'Mobile Games',
    labelKey: 'dbi_mobile_games',
    value: 'mobile',
    key: 'mobileGame',
    enumType: 'gameCategory',
  },
  pcGame: {
    label: 'PC Game',
    labelKey: 'dbi_pc_games',
    value: 'pc',
    key: 'pcGame',
    enumType: 'gameCategory',
  },
  consoleGame: {
    label: 'Console Game',
    labelKey: 'dbi_console_games',
    value: 'console',
    key: 'consoleGame',
    enumType: 'gameCategory',
  },
};

export const DATA_CATEGORY: IDataCategory = {
  operation: {
    label: 'Operation Data',
    labelKey: 'dbi_market_operation_data',
    value: 'operation',
    key: 'operation',
    enumType: 'dataCategory',
  },
  byGames: {
    label: 'By Games',
    labelKey: 'dbi_market_by_game',
    value: 'games',
    key: 'byGames',
    enumType: 'dataCategory',
  },
  byCountries: {
    label: 'By Countries',
    labelKey: 'dbi_genre_profile_by_countries',
    value: 'countries',
    key: 'byCountries',
    enumType: 'dataCategory',
  },
  byCompanies: {
    label: 'By Companies',
    labelKey: 'dbi_market_by_companies',
    value: 'companies',
    key: 'byCompanies',
    enumType: 'dataCategory',
  },
  byMainGenre: {
    label: 'By Main Genre',
    labelKey: 'dbi_market_by_main_genre',
    value: 'main_genres',
    key: 'byMainGenre',
    enumType: 'dataCategory',
  },
  bySubGenre: {
    label: 'By Sub Genre',
    labelKey: 'dbi_market_by_sub_genre',
    value: 'sub_genres',
    key: 'bySubGenre',
    enumType: 'dataCategory',
  }
};
